import { render } from "./ShipmentDetails.vue?vue&type=template&id=15ff6c67&scoped=true&ts=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=ts"
export * from "./ShipmentDetails.vue?vue&type=script&lang=ts"

import "./ShipmentDetails.vue?vue&type=style&index=0&id=15ff6c67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ff6c67"]])

export default __exports__